<template>
    <div>
        <img
            alt="Image"
            class="hero"
            src="../assets/OFX Hero Section copy.png"
        />
        <div class="container">
            <div class="row">
                <div class="col-sm">
                    <h5 class="text-left about">
                    </h5>
                    <hr />
                    <p class="text-left">
                        You will access the FDX API though our website –
                        <span class="target_links"
                            >www.financialdataexchange.org</span
                        >
                        <br />
                        Please use your username (email address) and password to
                        sign in. Once you have signed in you will see a tab for
                        the FDX API. Click on that. <br /><br />
                        <strong
                            >If you have any questions please reach out – we are
                            here to help.
                        </strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line
    name: "Welcome",
};
</script>

<style>
.hero {
    width: -webkit-fill-available;
    height: 400px;
}
/* .jumbotron{
background-image:url('../assets/Hero_img.png');
background-position: left;
} */
.about {
    font-weight: 500;
    font-size: 34px;
    line-height: 41px;
    color: #1978a0;
}
.contact-info {
    margin-left: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
hr {
    border: 1px solid #d8d8d8;
}
p {
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
.heading-level {
    font-size: 18px;
    line-height: 24px;
}
.target_links {
    color: #019382;
    text-decoration: underline;
}
@media (max-width: 600px) {

    .hero {
        height: 200px !important;
    }

}
@media (max-width: 378px) {

    .hero {
        height: 120px !important;
    }

}
</style>
